<nb-card>
  <nb-card-body>
    <ckeditor
      *ngIf="content != ''"
      [editor]="Editor"
      [disabled]="true"
      [config]="config"
      [(ngModel)]="content"
      class="content"
    ></ckeditor>
  </nb-card-body>
</nb-card>
